import apiService from "../ApiService";

export enum ActivationStatus {
  ACTIVATED = "ACTIVATED",
  INACTIVE = "inactive",
}

export const ubisoftGetActivation = (gameId: string) => {
  return apiService.get<{ revocableStatus: string; status: ActivationStatus }>({
    path: `v1/store/ubisoft/product/${gameId}`,
  });
};
